import { WorkOrderItemData } from '..';
import { useDisclosure } from '@/hooks';
import { useWorkorderDetailContext } from '../../../WorkorderDetailProvider';
import { WorkOrderComplementStatus } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { Divider } from 'antd';
import { EditIcon } from '@/components/_common';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import WorkOrderItemUpdateModal from '../../WorkOrderItemUpdateModal';
import { WorkOrderItemType } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';

interface Props {
  workOrderItem: WorkOrderItemData;
}

export default function WorkOrderItemEdit({ workOrderItem }: Props) {
  const [modalOpened, modalAction] = useDisclosure();

  const {
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const isClosed = complement?.status === WorkOrderComplementStatus.Closed;
  const isAuthorized =
    complement?.status === WorkOrderComplementStatus.Authorized;
  const isOpen = complement?.status === WorkOrderComplementStatus.Open;
  const isCancelled =
    complement?.status === WorkOrderComplementStatus.Cancelled;

  if (isClosed || isCancelled || workOrderItem.type === WorkOrderItemType.Kit)
    return null;

  return (
    <>
      <Divider type="vertical" />

      <EditIcon
        disabled={
          workOrderItem.disableEdit ||
          (isAuthorized &&
            !hasPermissions([
              Authorities.MOVIMENTATION_WORKORDER_AUTHORIZED_EDIT_ITEM,
            ])) ||
          (isOpen &&
            !hasPermissions([
              Authorities.MOVIMENTATION_WORKORDER_OPENED_EDIT_ITEM,
            ])) ||
          !hasPermissions([Authorities.MOVIMENTATION_WORKORDER_EDIT_ITEM])
        }
        iconProps={{ onClick: modalAction.open }}
      />

      <WorkOrderItemUpdateModal
        open={modalOpened}
        onCancel={modalAction.close}
        workorderItem={workOrderItem}
      />
    </>
  );
}
